import { Component, createElement } from 'react';
// @ts-expect-error untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
export default class FormattedMessage extends Component {
  render() {
    const {
      useGap,
      message,
      options
    } = this.props;
    const props = classNameFix(getPassThroughProps(this.props));
    return /*#__PURE__*/createElement('i18n-string', props, getValue({
      useGap,
      message,
      options
    }, true));
  }
}
FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextType = I18nHMRContext;
FormattedMessage.isI18nElement = true;
FormattedMessage.defaultProps = {
  options: {},
  useGap: false
};